// extracted by mini-css-extract-plugin
export default {"wrapper":"CodeBlock_wrapper__U92i9","pre":"CodeBlock_pre__AsXZX"};